/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Agenda_Card_AddInputs */



/**
* | output |
* | --- |
* | "{title} — add to Wundo" |
*
* @param {Agenda_Card_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_card_add = /** @type {((inputs: Agenda_Card_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Card_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} — voeg toe aan Wundo`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} — ajouter à Wundo`)
	return /** @type {LocalizedString} */ (`${i?.title} — add to Wundo`)
});